import { useEffect, useRef } from 'react';

import { History, Location } from 'history';

import { useObservability } from 'src/helpers/observability';

type TrackPageViewProps = {
  history: History;
};

const getUrl = (location: Location) => `${location.pathname}${location.search}${location.hash}`;

const TrackJourneyPageView = ({ history }: TrackPageViewProps) => {
  const { trackJourneyEvent } = useObservability();

  const initUrl = useRef<string>();

  // Send page view events to Journey every time the URL changes, excluding when the app first loads.
  // (An initial page view event is already being sent in the cloudflare worker and we don't want to double-count.)
  useEffect(() => {
    if (!initUrl.current) {
      initUrl.current = getUrl(history.location);
    }
    const removeListener = history.listen((location) => {
      if (getUrl(location) !== initUrl.current) {
        trackJourneyEvent('platform', 'pageViewEvent', {});
        initUrl.current = getUrl(location);
      }
    });
    return () => removeListener();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default TrackJourneyPageView;
